module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"check":"Вы не дали разрешение на доступ к камере или микрофону.","p1":"Выберите меню «Safari» → «Настройки» и нажмите «Веб-сайты»;","p2":"Выберите по очереди Камера и Микрофон и установите «Разрешить» для сайта huntica.ai;","p3":"Закройте настройки и перезагрузите страницу.","more":"Подробнее на сайте","support":"поддержки Apple"}}')
  delete Component.options._Ctor
}
